export enum EColor { 
  Denim = "denim",
  FireBrick = "fire-brick",
  BlueViolet = "blue-violet",
  Elm = "elm",
  Laurel = "laurel",
  Sepia = "sepia",
  Gravel = "gravel",
  Grey = "grey",
  Charcoal = "charcoal",
  Red = "red",
  Blue = "blue",
  Lake = "lake",
  DarkPurple = "dark-purple",
  Green = "green",
  Brown = "brown",
  Tan = "tan",
  Orange = "orange",
  MilkPunch = "milk-punch",
  Yellow = "yellow",
  Blush = "blush",
  Charm = "charm",
  Fuchsia = "fuchsia",

  White = "white",
  ClearArea = "clear-area",
  Content = "content",
  Inherit = "inherit",

  GravelToBlue = "gravel-to-blue",
  ClearToBlue = "clear-to-blue",
  ClearToRed = "clear-to-red",
  InputColor = "input-color",
  GreyToBlue = "grey-to-blue",
  GreyToRed  = "grey-to-red",

  Purple = "purple",
  LightGrey = "light-grey",
  DarkGrey = "dark-grey",
  DarkGreen = "dark-green",
  DarkBlue = "dark-blue",
  DarkBrown = "dark-brown",
  Prelorous = "prelorous",
};